import { FC, useState } from 'react'
import { useReward } from 'react-rewards'
import { CheckCheckIcon, CheckSquareIcon, CircleSlashIcon } from 'lucide-react'
import { useAppSelector } from '../../../redux'
import { useCourse } from '../../../utils'
import { StyledLessonButton } from '.'

const LessonButton: FC = () => {
  const { toggleLessonComplete } = useCourse()
  const { lesson, loading } = useAppSelector((state) => state.course)
  const { reward } = useReward('confetti', 'confetti', {
    angle: -90,
    startVelocity: 18,
    spread: 220,
    elementCount: 150
  })

  const handleClick = () => {
    if (!lesson?.isCompleted) {
      reward()
    }
    toggleLessonComplete(lesson, true)
  }

  return (
    <StyledLessonButton
      $complete={lesson?.isCompleted}
      $loading={loading}
      disabled={loading}
      onClick={() => handleClick()}
    >
      {!loading && !lesson?.isCompleted && (
        <>
          Complete Lesson
          <CheckSquareIcon />
        </>
      )}
      {!loading && lesson?.isCompleted && (
        <>
          <span className="completed-text text-anim">
            Completed Lesson
            <CheckCheckIcon />
          </span>
          <span className="uncomplete-text text-anim">
            Uncomplete Lesson
            <CircleSlashIcon />
          </span>
        </>
      )}
    </StyledLessonButton>
  )
}

export default LessonButton
